import { useEffect, useState } from "react";
import { Alert, Button, Progress } from "antd";
import { useGetMyProfileCompletionStatusQuery } from "../../services/me";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";

interface IProfileCompletionProps {
    userId?: string;
}

const ProfileCompletion = (props: IProfileCompletionProps) => {
    const { userId } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [completionStatus, setCompletionStatus] = useState<any>(null);
    const {
        data: profileCompletion,
        isSuccess: isProfileCompletionSuccess,
        isFetching: isProfileCompletionFetching
    } = useGetMyProfileCompletionStatusQuery();

    useEffect(() => {
        if (isProfileCompletionSuccess && profileCompletion?.data) {
            setCompletionStatus(profileCompletion.data);
        }
    }, [isProfileCompletionFetching])

    const gotoProfile = () => {
        navigate(ROUTES.PATHS.PROFILE);
    };

    return (
        <div className="w-[100%]">
            {Math.round(completionStatus?.percentage || 0) < 100 &&
                <Alert type="warning" closable className="profile-completion-warning"
                    message={t("Profile completion warning")}
                    description={<>
                        <Progress
                            percent={Math.round(completionStatus?.percentage || 0)}
                            strokeWidth={15}
                            strokeColor={"#52c41a"}
                        />
                        <div className="w-[100%]">
                            {t("Please complete")} <Button type="link" className="pl-0 ml-0" onClick={() => gotoProfile()} >{t("your profile")}</Button>
                        </div>
                    </>}
                />}
        </div>
    );
};

export default ProfileCompletion;
